// extracted by mini-css-extract-plugin
export default {"HeroContainer":"SearchMenu_HeroContainer__2JcPX","Search":"SearchMenu_Search__ZId43","Trending":"SearchMenu_Trending__Ad2Be","mainSection":"SearchMenu_mainSection__Bcfv+"};